
































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
    AgentsOverviewResponse,
    AgentDto,
    ConnectionDto,
    HeartbeatDto,
    CommandDto,
    CommandResultDto,
    AuditEventDto
} from '@/shared/dtos/agents-admin';

@Component
export default class OverviewTab extends Vue {
    @Prop() public overview!: AgentsOverviewResponse;
    @Prop() public agents: AgentDto[] = [];
    @Prop() public connections: ConnectionDto[] = [];
    @Prop() public heartbeats: HeartbeatDto[] = [];
    @Prop() public commands: CommandDto[] = [];
    @Prop() public commandResults: CommandResultDto[] = [];
    @Prop() public auditEvents: AuditEventDto[] = [];
    @Prop() public loading: boolean = false;

    public agentHeaders = [
        { text: 'Agente', value: 'agent_id', sortable: true },
        { text: 'Online', value: 'online', sortable: true, width: '110px' },
        { text: 'Último visto', value: 'last_seen', sortable: true },
        { text: 'Último heartbeat', value: 'last_heartbeat', sortable: true }
    ];

    public get effectiveAgents(): AgentDto[] {
        if (this.agents && this.agents.length > 0) return this.agents;
        const ov: any = this.overview || {};
        return Array.isArray(ov.agents) ? ov.agents : [];
    }

    public get totalAgents(): number {
        return this.effectiveAgents.length;
    }

    public get onlineAgents(): number {
        return this.effectiveAgents.filter(a => this.isAgentOnline(a)).length;
    }

    public get activeConnections(): number {
        return this.connections.filter(c => c.connection_status === 1 && c.is_current).length;
    }

    public get heartbeatsLastHour(): number {
        const now = new Date().getTime();
        const oneHour = 60 * 60 * 1000;
        return this.heartbeats.filter(h => {
            if (!h.received_at_utc) return false;
            return now - h.received_at_utc.getTime() <= oneHour;
        }).length;
    }

    public get commandResults24h(): CommandResultDto[] {
        const now = new Date().getTime();
        const oneDay = 24 * 60 * 60 * 1000;
        return this.commandResults.filter(r => {
            const d = r.created_at || r.finished_at || r.started_at;
            if (!d) return false;
            return now - d.getTime() <= oneDay;
        });
    }

    public get commandSuccessRate(): number {
        if (this.commandResults24h.length === 0) return 0;
        const ok = this.commandResults24h.filter(r => r.success).length;
        return Math.round((ok * 100) / this.commandResults24h.length);
    }

    public get errorAuditEvents24h(): number {
        const now = new Date().getTime();
        const oneDay = 24 * 60 * 60 * 1000;
        return this.auditEvents.filter(e => {
            if (!e.created_at) return false;
            const isRecent = now - e.created_at.getTime() <= oneDay;
            const t = (e.event_type || '').toLowerCase();
            return isRecent && (t.indexOf('error') >= 0 || t.indexOf('fail') >= 0 || t.indexOf('reject') >= 0);
        }).length;
    }

    public get latestHeartbeats(): HeartbeatDto[] {
        return [...this.heartbeats]
            .sort((a, b) => (b.received_at_utc ? b.received_at_utc.getTime() : 0) - (a.received_at_utc ? a.received_at_utc.getTime() : 0))
            .slice(0, 8);
    }

    public get recentAuditEvents(): AuditEventDto[] {
        return [...this.auditEvents]
            .sort((a, b) => (b.created_at ? b.created_at.getTime() : 0) - (a.created_at ? a.created_at.getTime() : 0))
            .slice(0, 10);
    }

    public get latestCommands(): CommandDto[] {
        return [...this.commands]
            .sort((a, b) => (b.created_at ? b.created_at.getTime() : 0) - (a.created_at ? a.created_at.getTime() : 0))
            .slice(0, 8);
    }

    public get agentRows(): any[] {
        const lastHbByAgent: { [key: string]: Date | null } = {};
        this.heartbeats.forEach(h => {
            const id = h.agent_id || '';
            if (!id || !h.received_at_utc) return;
            const prev = lastHbByAgent[id];
            if (!prev || h.received_at_utc.getTime() > prev.getTime()) {
                lastHbByAgent[id] = h.received_at_utc;
            }
        });

        return this.effectiveAgents.map(a => ({
            agent_id: a.agent_id,
            online: this.isAgentOnline(a),
            last_seen: a.last_seen_at,
            last_heartbeat: lastHbByAgent[a.agent_id] || null
        }));
    }

    public formatDate(date: Date | null): string {
        if (!date) return 'N/A';
        return new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(date);
    }

    public commandStatusText(status: number): string {
        switch (status) {
            case 0: return 'Pendiente';
            case 1: return 'Enviado';
            case 2: return 'Aceptado';
            case 3: return 'En ejecución';
            case 4: return 'Éxito';
            case 5: return 'Fallido';
            case 6: return 'Timeout';
            case 7: return 'Rechazado';
            case 8: return 'Cancelado';
            default: return 'Desconocido';
        }
    }

    public hbKey(hb: HeartbeatDto): string {
        const d = hb.received_at_utc ? hb.received_at_utc.getTime() : 0;
        return `${hb.agent_id}-${d}`;
    }

    private isAgentOnline(agent: AgentDto): boolean {
        if (!agent) return false;
        if (agent.status === 2) return true;

        if (agent.last_seen_at) {
            const now = new Date().getTime();
            const diff = now - agent.last_seen_at.getTime();
            return diff <= 2 * 60 * 1000;
        }

        return false;
    }
}
